import { Transfer } from 'antd';
import { difference, uniqBy } from 'lodash';
import React, { Component, Fragment } from 'react';
import Table from '../../_table/Table';
import { setIfNull } from '../../../lib/common';
import './TableTansfer.scss';

class TableTransfer extends Component {
  /**
   * 데이터 이동 시 callback
   */
  onChange = (newKeyList, direction, moveKeys) => {
    const { onChange } = this.props;
    onChange(direction === 'right' ? 'add' : 'remove', moveKeys);
  };

  render() {
    const {
      leftTitle,
      rightTitle,
      itemUnit = '개',
      itemsUnit = '개',
      bordered = true,
      leftTableProps,
      rightTableProps,
      ...rest
    } = this.props;

    const leftDataSource = rest.dataSource || [];
    const rightList = rightTableProps.list || [];
    const targetKeys = rightList.map((item) => item.id);
    const mergedDataSource = uniqBy([...leftDataSource, ...rightList], 'id');

    return (
      <Fragment>
        <div className="table-transfer-info">
          선택된 아이템은 <span className="gray">회색</span>으로 보이게 되며, 선택이 되지 않습니다.{' '}
        </div>

        <Transfer
          className={'table-transfer'}
          rowKey={(record) => record.id}
          titles={[setIfNull(leftTitle), setIfNull(rightTitle)]}
          locale={{
            itemUnit,
            itemsUnit,
          }}
          showSelectAll={false}
          {...rest}
          dataSource={mergedDataSource}
          targetKeys={targetKeys}
          onChange={this.onChange}
        >
          {({
            direction,
            filteredItems,
            onItemSelectAll,
            onItemSelect,
            selectedKeys: listSelectedKeys,
            disabled: listDisabled,
          }) => {
            const targetTableProps = direction === 'left' ? leftTableProps : rightTableProps;

            let updatedProps = {};
            if (targetTableProps.rowClassName) {
              updatedProps = {
                rowClassName: targetTableProps.rowClassName,
                rowSelection: {
                  getCheckboxProps: (item) => ({ disabled: listDisabled || item.disabled }),
                },
              };
            }
            return (
              <Fragment>
                {targetTableProps.headInfo}

                <Table
                  rowKey={(record) => record.id}
                  columns={targetTableProps.columns}
                  list={direction === 'right' ? targetTableProps.list : leftDataSource}
                  {...updatedProps}
                  size="small"
                  scroll={{ x: true }}
                  bordered={bordered}
                  initialOption={targetTableProps.initialOption}
                  onCheck={(list, selectedId, selected) => {
                    if (selectedId != null) {
                      onItemSelect(selectedId, selected);
                    } else {
                      onItemSelectAll(
                        selected ? difference(list, listSelectedKeys) : difference(listSelectedKeys, list),
                        selected,
                      );
                    }
                  }}
                  selectedList={listSelectedKeys}
                  getList={targetTableProps.getList}
                  pagination={targetTableProps.pagination}
                  filterOption={targetTableProps.filterOption}
                  sortOption={targetTableProps.sortOption}
                  canDrag={targetTableProps.canDrag}
                  onDragEnd={targetTableProps.onDragEnd}
                />
              </Fragment>
            );
          }}
        </Transfer>
      </Fragment>
    );
  }
}

export default TableTransfer;
